export default{
    base_url:'https://api.elcaminoconcorreos.com',
    grant_type:'password',
    client_id:'develop.rutasmeigas',
    client_secret:'E2FC184D10D2352F7085CAE4309D1504',
    username: 'sistemas@rutasmeigas.com',
    password: 'RutasmeigasCorreos2026',

    correos_access_token: null,

    caminos_correos: [],
}